// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `select {
  width: 100%;
  height: 35px;
  margin: 0 0 15px 0;
  outline: none;
  padding: 0 10px 0 10px;
  border: solid 1px #e2e2e2;
  border-radius: 3px;
  background-image: url("/assets/img/arrow-down.png");
  background-size: 30px;
  background-repeat: no-repeat;
  background-position-x: calc(100% - 10px);
  background-position-y: 6px;
}

select::-ms-expand {
  display: none;
}

select {
  appearance: none;
}

.logo-banco {
  background-size: 75px 75px;
  width: 75px;
  height: 75px;
  margin: 0 auto;
  transition: 0.5s;
}
.logo-banco.bradesco {
  background-image: url('logo-bradesco.png');
}
.logo-banco.santander {
  background-image: url('logo-santander.png');
}
.logo-banco.grayscale {
  filter: grayscale(100%);
  opacity: 0.3;
  transition: 0.5s;
}

.cedente {
  background-color: rgba(0, 0, 0, 0);
  transition: 1s;
}
.cedente.padrao {
  background-color: #FFF;
  transition: 1s;
}

.menu-button {
  width: 7px;
  height: 19px;
  display: block;
  background-image: url(/assets/icones/menu-edit.svg);
  background-repeat: no-repeat;
  padding: 10px;
  background-position: center;
  cursor: pointer;
  float: right;
  position: relative;
  top: -40px;
}
.menu-button .menu {
  position: relative;
  left: -119px;
  top: -10px;
  background-color: #fff;
  width: 100px;
  height: 60px;
  border: none;
  border-radius: 3px;
  box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);
}
.menu-button .menu .menu-option {
  line-height: 30px;
  text-align: center;
  transition: 0.5s;
}
.menu-button .menu .menu-option:hover {
  background-color: rgba(226, 226, 226, 0.5);
  transition: 0.5s;
}

.radio-padrao {
  margin-bottom: 20px;
  margin-left: 5px;
}
.radio-padrao span {
  font-style: italic;
  color: #cccccc;
}
.radio-padrao .error-message {
  color: #e57373;
  float: right;
  text-align: right;
  position: relative;
  right: 50px;
}

.animate-card-down-adquirente {
  animation-duration: 1s;
  animation-name: animate-height-down-adquirente;
  animation-fill-mode: forwards;
  transition: height 0.3s;
}

@keyframes animate-height-down-adquirente {
  from {
    height: 40px;
  }
  to {
    height: 270px;
  }
}
.animate-card-up-adquirente {
  animation-duration: 1s;
  animation-name: animate-height-up-adquirente;
  animation-fill-mode: forwards;
  transition: height 0.3s;
}

@keyframes animate-height-up-adquirente {
  from {
    height: 270px;
  }
  to {
    height: 40px;
  }
}
.remove {
  animation-duration: 1s;
  animation-name: animate-remove;
  animation-fill-mode: forwards;
  transition: height 0.2s;
}

@keyframes animate-remove {
  from {
    height: 220px;
  }
  to {
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
    height: 0px;
  }
  100% {
    opacity: 0;
  }
}
.card {
  height: 220px;
}

@media (max-width: 767px) {
  .card {
    height: auto;
  }
  form > div:last-child {
    margin-top: 30px;
    text-align: center;
  }
}
.adquirente img {
  position: absolute;
  top: 31px;
  left: 50%;
  transform: translatex(-59%);
  width: 62px;
}

.adquirente select {
  padding: 0 0 0 70px;
}

select {
  width: 100%;
  outline: none;
  padding: 0 10px 0 10px;
  border: solid 2px #e2e2e2;
  background-image: url("/assets/img/arrow-down.png");
  background-size: 30px;
  background-repeat: no-repeat;
  background-position-x: calc(100% - 10px);
  background-position-y: 6px;
}

.logo-adquirente {
  width: 75px;
  height: auto;
  min-height: 75px;
  margin: 0 auto;
  position: relative;
}
.logo-adquirente img {
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.dropdown-toggle {
  border: solid 1px #e2e2e2;
  color: #777777;
  height: 40px;
  border-radius: 6px;
  background-color: #ffffff;
  font-size: 13px;
}

.dropdown.open .dropdown-toggle {
  background-color: #ffffff;
  box-shadow: none;
  border: solid 1px #e2e2e2;
}

.btn:not(.disabled):not(:disabled):active, .btn:not(.disabled):not(:disabled).active {
  box-shadow: none;
}

.dropdown-menu {
  box-shadow: 2px 2px 2px #eee;
  border: solid 1px #e2e2e2;
  margin-top: 1px;
  border-radius: 6px;
}

.dropdown-menu li:first-child {
  border-bottom: solid 1px #eee;
}

.dropdown-menu li img {
  width: 50px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.dropdown-menu li a {
  padding: 10px 20px;
}

.dropdown-menu li a:hover {
  background-color: rgba(34, 183, 255, 0.3);
  cursor: pointer;
}

.dropdown .caret {
  margin-left: 15px;
}

.dropdown-toggle img {
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/minha-conta/configuracoes/card-adquirente/card-adquirente.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mDAAA;EACA,qBAAA;EACA,4BAAA;EACA,wCAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EAEI,gBAAA;AAAJ;;AAGA;EACI,0BAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAAJ;AACI;EACI,0CAAA;AACR;AACI;EACI,2CAAA;AACR;AACI;EAEI,uBAAA;EACA,YAAA;EACA,gBAAA;AACR;;AAGA;EACI,kCAAA;EACA,cAAA;AAAJ;AACI;EACI,sBAAA;EACA,cAAA;AACR;;AAGA;EACI,UAAA;EACA,YAAA;EACA,cAAA;EACA,mDAAA;EACA,4BAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAAJ;AACI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,sBC7CA;ED8CA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;AACR;AAAQ;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;AAEZ;AAAQ;EACI,0CAAA;EACA,gBAAA;AAEZ;;AAGA;EACI,mBAAA;EACA,gBAAA;AAAJ;AACI;EACI,kBAAA;EACA,cC1EI;AD2EZ;AACI;EACI,cC9DC;ED+DD,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AACR;;AAGA;EACI,sBAAA;EACA,8CAAA;EACA,6BAAA;EACA,uBAAA;AAAJ;;AAGA;EACI;IACI,YAAA;EAAN;EAEE;IACI,aAAA;EAAN;AACF;AAGA;EACI,sBAAA;EACA,4CAAA;EACA,6BAAA;EACA,uBAAA;AADJ;;AAIA;EACI;IACI,aAAA;EADN;EAGE;IACI,YAAA;EADN;AACF;AAIA;EACI,sBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;AAFJ;;AAKA;EACI;IACI,aAAA;EAFN;EAIE;IACI,gBAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,WAAA;EAFN;EAIE;IACI,UAAA;EAFN;AACF;AAKA;EACI,aAAA;AAHJ;;AAMA;EACI;IACI,YAAA;EAHN;EAKE;IACI,gBAAA;IACA,kBAAA;EAHN;AACF;AAMA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AAJJ;;AAOA;EACI,mBAAA;AAJJ;;AAOA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mDAAA;EACA,qBAAA;EACA,4BAAA;EACA,wCAAA;EACA,0BAAA;AAJJ;;AAOA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAJJ;AAKI;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AAHR;;AAOA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAJF;;AAOA;EACE,yBAAA;EACA,gBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,4BAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAJF;;AAOA;EACE,6BAAA;AAJF;;AAOA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,yCAAA;EACA,eAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,YAAA;AAJF","sourcesContent":["@import '../../../../../../../sass/variables';\nselect {\n    width: 100%;\n    height: 35px;\n    margin: 0 0 15px 0;\n    outline: none;\n    padding: 0 10px 0 10px;\n    border: solid 1px $cinza-300;\n    border-radius: 3px;\n    background-image: url(\"/assets/img/arrow-down.png\");\n    background-size: 30px;\n    background-repeat: no-repeat;\n    background-position-x: calc(100% - 10px);\n    background-position-y: 6px;\n}\n\nselect::-ms-expand {\n    display: none;\n}\n\nselect {\n    -webkit-appearance: none;\n    appearance: none;\n}\n\n.logo-banco {\n    background-size: 75px 75px;\n    width: 75px;\n    height: 75px;\n    margin: 0 auto;\n    transition: 0.5s;\n    &.bradesco {\n        background-image: url('./../../../../../../../assets/img/logo-bradesco.png');\n    }\n    &.santander {\n        background-image: url('./../../../../../../../assets/img/logo-santander.png');\n    }\n    &.grayscale {\n        -webkit-filter: grayscale(100%);\n        filter: grayscale(100%);\n        opacity: 0.3;\n        transition: 0.5s;\n    }\n}\n\n.cedente {\n    background-color: rgba(0, 0, 0, 0);\n    transition: 1s;\n    &.padrao {\n        background-color: #FFF;\n        transition: 1s;\n    }\n}\n\n.menu-button {\n    width: 7px;\n    height: 19px;\n    display: block;\n    background-image: url(/assets/icones/menu-edit.svg);\n    background-repeat: no-repeat;\n    padding: 10px;\n    background-position: center;\n    cursor: pointer;\n    float: right;\n    position: relative;\n    top: -40px;\n    .menu {\n        position: relative;\n        left: -119px;\n        top: -10px;\n        background-color: $white;\n        width: 100px;\n        height: 60px;\n        border: none;\n        border-radius: 3px;\n        box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);\n        .menu-option {\n            line-height: 30px;\n            text-align: center;\n            transition: 0.5s;\n        }\n        .menu-option:hover {\n            background-color: rgba($cinza-300, 0.5);\n            transition: 0.5s;\n        }\n    }\n}\n\n.radio-padrao {\n    margin-bottom: 20px;\n    margin-left: 5px;\n    span {\n        font-style: italic;\n        color: $cinza-400;\n    }\n    .error-message {\n        color: $danger;\n        float: right;\n        text-align: right;\n        position: relative;\n        right: 50px;\n    }\n}\n\n.animate-card-down-adquirente {\n    animation-duration: 1s;\n    animation-name: animate-height-down-adquirente;\n    animation-fill-mode: forwards;\n    transition: height 0.3s;\n}\n\n@keyframes animate-height-down-adquirente {\n    from {\n        height: 40px;\n    }\n    to {\n        height: 270px;\n    }\n}\n\n.animate-card-up-adquirente {\n    animation-duration: 1s;\n    animation-name: animate-height-up-adquirente;\n    animation-fill-mode: forwards;\n    transition: height 0.3s;\n}\n\n@keyframes animate-height-up-adquirente {\n    from {\n        height: 270px;\n    }\n    to {\n        height: 40px;\n    }\n}\n\n.remove {\n    animation-duration: 1s;\n    animation-name: animate-remove;\n    animation-fill-mode: forwards;\n    transition: height 0.2s;\n}\n\n@keyframes animate-remove {\n    from {\n        height: 220px;\n    }\n    to {\n        padding-top: 0px;\n        padding-bottom: 0px;\n        margin-top: 0px;\n        margin-bottom: 0px;\n        height: 0px;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n.card {\n    height: 220px;\n}\n\n@media (max-width: 767px) {\n    .card {\n        height: auto;\n    }\n    form>div:last-child {\n        margin-top: 30px;\n        text-align: center;\n    }\n}\n\n.adquirente img {\n    position: absolute;\n    top: 31px;\n    left: 50%;\n    transform: translatex(-59%);\n    width: 62px;\n}\n\n.adquirente select {\n    padding: 0 0 0 70px;\n}\n\nselect {\n    width: 100%;\n    outline: none;\n    padding: 0 10px 0 10px;\n    border: solid 2px $cinza-300;\n    background-image: url(\"/assets/img/arrow-down.png\");\n    background-size: 30px;\n    background-repeat: no-repeat;\n    background-position-x: calc(100% - 10px);\n    background-position-y: 6px;\n}\n\n.logo-adquirente {\n    width: 75px;\n    height: auto;\n    min-height: 75px;\n    margin: 0 auto; //  margin-top: 30px;\n    position: relative;\n    img {\n        width: 100%;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n    }\n}\n\n.dropdown-toggle {\n  border: solid 1px #e2e2e2;\n  color: #777777;\n  height: 40px;\n  border-radius: 6px;\n  background-color: #ffffff;\n  font-size: 13px;\n}\n\n.dropdown.open .dropdown-toggle {\n  background-color: #ffffff;\n  box-shadow: none;\n  border: solid 1px #e2e2e2;\n}\n\n.btn:not(.disabled):not(:disabled):active, .btn:not(.disabled):not(:disabled).active {\n  box-shadow: none;\n}\n\n.dropdown-menu {\n  box-shadow: 2px 2px 2px #eee;\n  border: solid 1px #e2e2e2;\n  margin-top: 1px;\n  border-radius: 6px;\n}\n\n.dropdown-menu li:first-child {\n  border-bottom: solid 1px #eee;\n}\n\n.dropdown-menu li img {\n  width: 50px;\n  position: relative;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.dropdown-menu li a {\n  padding: 10px 20px;\n}\n\n.dropdown-menu li a:hover {\n  background-color: rgba($azul-400, 0.3);\n  cursor: pointer;\n}\n\n.dropdown .caret {\n  margin-left: 15px;\n}\n\n.dropdown-toggle img {\n  height: 20px;\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
